import { Table } from '@shared/Table'
import { columns } from '../../constants/LimitTypeColums'
import {} from '../../constants/LimitTypeColums'
import React from 'react'

function LimitTypeTable({ data }) {
  return (
    <Table
      tableKey="orderDetailTable"
      editColumns={columns()}
      dataSource={data.limitTypeList}
      pagination={false}
      size="small"
      scroll={{ x: '100%' }}
    />
  )
}

export default LimitTypeTable
